export const env: {
  apiBase: string;
  upcApiBase: string;
} = {
  apiBase: process.env.VUE_APP_BASE_URL || '',
  upcApiBase: process.env.VUE_APP_BASE_URL || ''
};
